import React from 'react'; 
import {Button, FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import {injectIntl} from 'react-intl';
import {inject, observer} from 'mobx-react';
import IgBusinessStore from './stores/IgBusinessStore';
import EditableTextarea from '../common_components/EditableTextarea';


@injectIntl @inject("rootStore")
@observer
export default class DefaultForm extends React.Component{

  constructor(props){
    super(props);

    this.handleDetailsChange = this.handleDetailsChange.bind(this);
  }

  render(){
    const {intl} = this.props;
    const detailsEdit = this.props.rootStore.activityStore.detailsEdit;
    const card =  this.props.rootStore.activityStore.activityEdit.preselectedCard;
    const cardDetails = this.props.rootStore.activityStore.activityEdit.preselectedCardDetails;
    const cardSelected = this.props.rootStore.activityStore.activityEdit.isSelected(card);

    return(
      <EditableTextarea 
        label={intl.formatMessage({id: "details"})}
        text={cardDetails}
        saveButtonLabel={intl.formatMessage({id: "save"})}
        cancelButtonLabel={intl.formatMessage({id: "cancel"})}
        onSubmit={this.handleDetailsChange}
        canEdit
        labelClassName={"default-form-label"}
       />
    )

  }

  handleDetailsChange(text){
    const card =  this.props.rootStore.activityStore.activityEdit.preselectedCard;
    this.props.rootStore.activityStore.activityEdit.handleDetailsChange(text, card.id);
  }

}